exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.switch.switch-3d[data-v-932f2c08] {\n  float: right;\n}\n.card[data-v-932f2c08] {\n  background: #ebeff3;\n  border-radius: 10px;\n}\n.card .bar[data-v-932f2c08] {\n    width: 100%;\n    height: 10px;\n    border-radius: 10px 10px 0 0;\n}\n.card .card-header[data-v-932f2c08] {\n    border-radius: 10px 10px 0 0;\n    background-color: #e7e7e7;\n    padding: 1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-932f2c08","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/localTime.vue
// module id = 1366
// module chunks = 2